(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/shared-components/doc-item.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/shared-components/doc-item.js');
'use strict';

const {
  ListItem
} = svs.ui.ReactListGroup;
const {
  ReactIcon: Icon
} = svs.ui;
const displaySize = (bytes, documentMime) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  let fileType = 'pdf';
  if (documentMime) {
    fileType = documentMime.split('/')[1];
  }
  if (bytes === 0) {
    return '';
  }
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) {
    return "".concat(fileType, ", ").concat(bytes, " ").concat(sizes[i]);
  }
  return "".concat(fileType, ", ").concat((bytes / 1024 ** i).toFixed(0), " ").concat(sizes[i]);
};
const DocItem = _ref => {
  var _svs;
  let {
    docItem
  } = _ref;
  const {
    title,
    documentSize,
    documentUrl
  } = docItem;
  const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
  return React.createElement(ListItem, null, React.createElement("a", {
    "aria-label": "\xD6ppna PDF-fil, ".concat(title, ", i ny flik"),
    className: "u-text-reset u-flex u-flex-no-wrap",
    href: cdn + documentUrl,
    rel: "noreferrer",
    target: "_blank"
  }, React.createElement("div", null, React.createElement(Icon, {
    icon: "document",
    size: "100"
  })), React.createElement("div", {
    className: "margin-xs-h-1 u-flex-fill"
  }, title), React.createElement("div", {
    className: "align-right terms-integrity-no-wrap"
  }, displaySize(documentSize))));
};


svs.termsIntegrity.sharedComponents.DocItem = DocItem;

 })(window);